import { Button, Icon, Text } from '@/design-system'
import { cn } from '@/lib/cn'
import styles from './States.module.css'

export function Skeleton({ height, className }: { readonly height: number; readonly className?: string }) {
  return <div className={cn(styles.skeleton, className)} style={{ height }} aria-hidden="true" />
}

export function ErrorState({ message }: { readonly message: string }) {
  return (
    <div className={styles.block} role="alert">
      <Icon name="error" size={24} />
      <Text variant="caption" tone="secondary">
        {message}
      </Text>
    </div>
  )
}

export function EmptyState({
  icon,
  title,
  body,
  action,
}: {
  readonly icon: string
  readonly title: string
  readonly body?: string | undefined
  /** A way out of the empty state, so it is never a dead end. */
  readonly action?: { readonly label: string; readonly onClick: () => void } | undefined
}) {
  return (
    <div className={styles.block}>
      <Icon name={icon} size={24} />
      <Text variant="body" weight="semibold">
        {title}
      </Text>
      {body && (
        <Text variant="caption" tone="secondary">
          {body}
        </Text>
      )}
      {action && (
        <Button variant="outline" size="sm" onClick={action.onClick} className="pb-mt-3">
          {action.label}
        </Button>
      )}
    </div>
  )
}
